import React from 'react';
import Header from '../components/Header';
import ProductsComponent from '../components/Products';
import Footer from '../components/Footer';

const Products = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <ProductsComponent />
      </main>
      <Footer />
    </div>
  );
};

export default Products;